import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import { PermissionChecker } from '../../session'
import Container from '../../../components/structure/Container'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import PageHeader from './PageHeader'
import AddNewButton from './AddNewButton'
import StockItemsLoader from './_load/StockItemsLoader'
import StocksTable from './table/StocksTable'
import MultiRowsActions from './table/MultiRowsActions'
import ControlBar from './ControlBar'
import Separator from '../../../packages/kiti/components/helpers/Separator'

export default function StocksListPage() {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="listStocks">
        <Container>
          <PageHeader />
          <FilterHandler>
            <ControlBar />
            <MultiSelectHandler>
              <StockItemsLoader uncontrolledChildren={<MultiRowsActions />}>
                <StocksTable />
              </StockItemsLoader>
            </MultiSelectHandler>
          </FilterHandler>
          <AddNewButton />
        </Container>
        <Separator weight={32} />
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}
